// extracted by mini-css-extract-plugin
module.exports = {"button":"_ba30905","process":"_084effc"};